/** Normalise labels for matching portal names to applicant mandal / village strings. */
export function normalizeGeoLabel(s: string): string {
  return s.trim().toLowerCase().replace(/\s+/g, " ");
}
